module.exports = __webpack_public_path__ + "static/media/console-fuel-filler.a6994252.jpg";